var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "no-stroke",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3767 0.123323C16.5411 0.287755 16.5411 0.554351 16.3767 0.718782L11.5694 5.52611C11.4049 5.69054 11.1383 5.69054 10.9739 5.52611C10.8095 5.36168 10.8095 5.09508 10.9739 4.93065L15.7812 0.123323C15.9457 -0.0411078 16.2123 -0.0411078 16.3767 0.123323Z",
    fill: "#6D819C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "no-stroke",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1104 0.421053C11.1104 0.188512 11.2989 0 11.5314 0H16.0788C16.3113 0 16.4998 0.188512 16.4998 0.421053V4.96842C16.4998 5.20096 16.3113 5.38947 16.0788 5.38947C15.8462 5.38947 15.6577 5.20096 15.6577 4.96842V0.842105H11.5314C11.2989 0.842105 11.1104 0.653594 11.1104 0.421053Z",
    fill: "#6D819C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "no-stroke",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98421 3.87336C3.86816 3.87336 1.34211 6.39941 1.34211 9.51546C1.34211 12.6315 3.86816 15.1576 6.98421 15.1576C10.1003 15.1576 12.6263 12.6315 12.6263 9.51546C12.6263 6.39941 10.1003 3.87336 6.98421 3.87336ZM0.5 9.51546C0.5 5.93433 3.40308 3.03125 6.98421 3.03125C10.5653 3.03125 13.4684 5.93433 13.4684 9.51546C13.4684 13.0966 10.5653 15.9997 6.98421 15.9997C3.40308 15.9997 0.5 13.0966 0.5 9.51546Z",
    fill: "#6D819C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMale);
export default __webpack_public_path__ + "static/media/ic-male.397d0daeef57ddd965b5fcc95fea362e.svg";
export { ForwardRef as ReactComponent };